import { evidencePowerUserDevForceEnabledAtom } from '@/atoms/evidenceTrialQueryCountAtom';
import { IS_EVIDENCE_POWER_USER_UPGRADE_MODAL_ENABLED } from '@/components/constants/flags';
import { ENV_NAME, getEnvironment } from '@heidi/api/config';
import { useAtomValue } from 'jotai';

/**
 * Single source of truth for whether the Evidence power-user experience (modal, chat
 * banner, dev overlay, trial-banner suppression) should be active for the current user.
 *
 * Enabled when either:
 *  - The PostHog flag `release-evidence-power-user-upgrade-modal` is on, OR
 *  - We're in a non-production build AND the dev-tools dev-force-enabled atom is true.
 *
 * The dev override is deliberately ignored in production builds as a safety net — even if
 * the atom somehow ends up `true` in a shipped build it cannot force the feature on.
 */
export const useIsEvidencePowerUserEnabled = (): boolean => {
  const devForceEnabled = useAtomValue(evidencePowerUserDevForceEnabledAtom);
  const flagEnabled = IS_EVIDENCE_POWER_USER_UPGRADE_MODAL_ENABLED();
  const isNonProduction = getEnvironment() !== ENV_NAME.PROD;
  return flagEnabled || (isNonProduction && devForceEnabled);
};
